// Адрес API продакшена (self-hosted Supabase).
// Сервер Timeweb 201.34.131.237: nginx api.biopeptideplus.ru → 127.0.0.1:8000 (self-hosted Supabase).
// Anon key берётся из VITE_SUPABASE_PUBLISHABLE_KEY (ключ self-hosted).
export const PROXY_SUPABASE_URL = "https://api.biopeptideplus.ru";
